import { supabase } from '@/integrations/supabase/client';

/**
 * Abre um documento interno (manuais, brochuras, dossiês) em nova aba
 * passando pela edge function autenticada `docs-internos`. Os arquivos
 * não estão mais em /public/docs e não podem ser acessados por URL direta.
 */
export async function openDocInterno(filename: string): Promise<void> {
  const { data: sessionData } = await supabase.auth.getSession();
  const accessToken = sessionData.session?.access_token;
  if (!accessToken) {
    throw new Error('Sessão expirada. Faça login novamente.');
  }

  const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/docs-internos?file=${encodeURIComponent(filename)}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    },
  });

  if (!res.ok) {
    const msg = await res.text().catch(() => '');
    throw new Error(`Falha ao carregar documento (${res.status}). ${msg}`);
  }

  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const win = window.open(blobUrl, '_blank', 'noopener,noreferrer');
  // libera o blob depois que a janela tiver carregado
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  if (!win) {
    throw new Error('Pop-up bloqueado pelo navegador.');
  }
}
